import { confirmationItemsJa } from '@/entities/confirmationItems';

export default {
    // サマータイム期間（2026/8/24-9/30）終了後は手動で取り下げる
    // 範囲を示す記号は文字化けを避けるため半角ハイフン（U+002D）を使用する
    summerTimeNotice: {
        delivery:
            '※夕方以降のお預かり分は最終便ですぐに出発するため、18:00のお預かりでも<strong>当日22:00頃</strong>までにお届けします。',
    },
    guide: {
        hotelGroupPrompt: '宿泊するホテルグループを選んでください',
        hotelGroupsError: 'ホテルの一覧を読み込めませんでした。時間をおいて再度お試しください。',
        title: '申込案内',
        newApplication: {
            sectionTitle: '初めてお申し込みの方はこちら',
            availableHotelsNotice: 'Air Luggage は現在、以下のホテルにお泊まりの方のみご利用いただけます。',
            hotel: '宿泊予定のホテル（店舗）',
            notListedHotel: '一覧に無いホテル',
            notListedHotelError:
                '選択したホテルは、まだお申し込みの対象外です。Air Luggage は、一覧のホテルにお泊まりの方のみご利用いただけます。',
            selectedHotelAddressLabel: 'ご予約のホテルの住所',
            selectedHotelAddressHint: '予約確認メールに記載の住所と同じかご確認ください。名前の似たホテルがあります。',
            submit: '申し込む',
        },
        existingApplication: {
            sectionTitle: 'すでにお申し込みの方はこちら',
            email: 'メールアドレス',
            userName: '申込者名',
            submit: '予約確認・配送状況',
            error: '申し込みデータが見つかりませんでした',
        },
        validation: {
            hotelRequired: '宿泊予定のホテルを選択してください',
            emailRequired: 'メールアドレスを入力してください',
            emailInvalid: '有効なメールアドレスを入力してください',
            userNameRequired: '申込者名を入力してください',
        },
    },
    input: {
        title: '配送予約入力',
        sections: {
            customerInfo: 'お客様情報',
            hotelInfo: 'ホテル情報',
            airportInfo: '日本の空港',
            pickupCounter: '預け入れカウンター',
            luggageInfo: 'お預入れのお荷物について',
            luggagePhoto: '荷物写真',
            termsOfService: '利用規約',
        },
        customerInfo: {
            reservationHolderName: '🔑 宿泊予約名義（ホテル予約時の名前）',
            reservationHolderNameHint: '<strong>ホテルの予約確認書に記載された通りの綴りで入力してください。</strong>',
            sameAsGuest: '宿泊予定者と同じ',
            userName: '申込者名（実際に荷物を預ける方）',
            userNameHint: '⚠️ 当日、カウンターで荷物を預ける本人の名前を入力してください。',
            relationshipWithGuest: '宿泊者とのご関係',
            selectPlaceholder: '選択してください',
            email: 'メールアドレス',
            emailHint:
                '当日お荷物を預ける方ご本人のメールアドレスを入力してください（前日のご案内・到着のお知らせが届きます）。旅行会社・添乗員の方がお申し込みの場合も、各お客様ご本人のアドレスをご入力ください。',
            phoneNumber: '電話番号',
            phoneNumberPlaceholder: '例：+81 90-0000-0000',
            phoneNumberHint:
                '国番号と電話番号をご入力ください。<br />※日本滞在中にご連絡可能な電話番号をお持ちの場合にご入力ください。',
            country: '国名',
        },
        hotelInfo: {
            hotelName: 'ホテル名',
            hotelAddress: 'ホテル住所',
            checkInDate: 'チェックイン日 <strong>（日本時間）</strong>',
            checkOutDate: 'チェックアウト日 <strong>（日本時間）</strong>',
        },
        airportInfo: {
            airportCounter: '空港・受付カウンター',
            arrivalDateTime: '到着・宿泊日程 <strong>(日本時間, GMT+9)</strong>',
            flightNumber: '便名（任意）',
        },
        pickupCounter: {
            arrivalDateTime: '到着・宿泊日程 <strong>(日本時間, GMT+9)</strong>',
            businessHours:
                '⚠️ カウンター受付時間：<strong>{startTime}〜{endTime}</strong>（日本時間）。{endTime}以降はお預かりできません。',
        },
        estimatedDelivery: {
            label: 'ホテル到着予定',
            message: '約{hours}〜{hoursUpper}時間で配達予定です',
        },
        luggageInfo: {
            quantity: '現時点でのお預入れ予定の荷物個数',
            hint: '現時点での予定個数をご入力ください。当日数量が変更になって問題ありません。当日カウンターでの荷物数に応じての精算となります。',
            freeUntil: '{date}までの配送は費用がかかりません。',
        },
        price: {
            label: '合計額（税込）',
            paymentNotice:
                '上記は予定個数での算出金額です。当日の荷物個数でカウンターで精算いたします。料金は当日空港カウンターでお支払いください。',
            priceTableLink: '料金表を見る',
            paymentMethodsNotice: 'クレジットカード・電子マネーのみの対応となります（現金非対応）',
            paymentMethodsLabel: '使える決済方法',
            paymentMethodsCashNote: '現金はご利用いただけません。',
            paidDateNotice: '{date}以降の配送は費用が発生いたします。金額は「合計額（税込）」をご確認ください。',
            priceTableTitle: '料金表',
            priceTableCaption: '{date}にお預けの場合（税込）',
            priceTableQuantity: '荷物の数',
            priceTableAmount: '合計額（税込）',
            priceTableCount: '{count}個',
            close: '閉じる',
        },
        luggagePhoto: {
            description: '荷物写真(最大3枚)',
            addButton: '写真を追加',
            count: '{current}/{max}枚',
            maxReached: '写真は最大3枚までです',
        },
        termsOfService: {
            agreeTerms: '利用規約に同意し、プライバシーポリシーを確認しました',
            variousLanguagesLink: 'さまざまな言語での利用規約',
        },
        submit: '確認画面へ進む',
        validation: {
            reservationHolderNameRequired: '宿泊予約名義を入力してください',
            userNameRequired: '申込者名を入力してください',
            relationshipWithGuestRequired: '宿泊者との関係を選択してください',
            emailRequired: 'メールアドレスを入力してください',
            emailInvalid: '有効なメールアドレスを入力してください',
            phoneNumberRequired: '電話番号を入力してください',
            countryRequired: '国名を入力してください',
            hotelRequired: 'ホテルを選択してください',
            checkInDateRequired: 'チェックイン日を入力してください',
            checkOutDateRequired: 'チェックアウト日を入力してください',
            airportRequired: '空港・受付カウンターを選択してください',
            arrivalDateRequired: '空港到着予定日を入力してください',
            arrivalTimeRequired: '空港到着予定時刻を入力してください',
            pickupDateRequired: '預け入れカウンター到着予定日を入力してください',
            pickupTimeRequired: '預け入れカウンター到着予定時刻を入力してください',
            luggageQuantityInteger: '荷物数は整数で入力してください',
            luggageQuantityMin: '荷物数は1以上で入力してください',
            luggageQuantityRequired: '荷物数を入力してください',
            luggagePhotosRequired: '荷物の写真を1枚以上追加してください',
            luggagePhotosMax: '写真は最大3枚までです',
            agreeTermsRequired: '利用規約に同意してください',
            phoneNumberFormat: '国番号と電話番号を正しく入力してください（ハイフンの有無は問いません）',
            checkOutDateAfterCheckIn: 'チェックアウト日はチェックイン日より後の日付を選択してください',
            pickupDateAfterArrival: '預け入れカウンター到着日時は空港到着日時以降を選択してください',
            checkInDateAfterArrival: 'チェックイン日は空港到着日以降の日付を選択してください',
            checkOutDateAfterPickup: 'チェックアウト日はカウンター到着日以降の日付を選択してください',
            pickupDateWithinCheckIn: '預け入れカウンター到着日はチェックイン日の当日または前日を選択してください',
            pickupDateUnavailable: '選択した日は、お申し込みいただけなくなりました。別の日付を選択してください。',
            luggageQuantityMax: '荷物の数は{max}個までで選択してください',
        },
    },
    edit: {
        title: '配送予約編集',
        editButton: '申し込み内容を編集する',
        back: '< 戻る',
        submit: '変更内容を保存する',
        priceChanged:
            '料金が変わりました。新しい合計額をご確認のうえ、もう一度「変更内容を保存する」を押してください。',
    },
    complete: {
        title: '予約完了<br>（マイページ）',
        editButton: '申し込み内容を編集する',
        sections: {
            pickupCounter: 'カウンター詳細',
        },
        serviceEnd: {
            title: 'サービス終了のご案内',
            thankYouMessage: 'Air Luggage をご利用いただき誠にありがとうございました',
            thankYouMessageWithHotel:
                '<strong>{hotelName}</strong> でのご宿泊、Air Luggage をご利用いただき誠にありがとうございました',
            description: 'お客様の荷物配送サービスは完了いたしました。',
            surveySection: {
                title: 'アンケートのお願い',
                description: 'サービス向上のため、アンケートにご協力ください。',
                buttonText: 'アンケートに回答する',
            },
            hotelLpSection: {
                title: '次回のご宿泊予約',
                description: '次回のご宿泊は、<strong>{hotelName}</strong> の公式サイトからご予約ください。',
                buttonText: 'ホテルサイトを見る',
            },
        },
        screenshotWarning: '⚠️ オフライン提示用に<strong>スクリーンショットを保存</strong>してください。',
        qrCode: {
            title: 'QR荷物配送パス（空港・ホテル提示用）',
            description:
                '<strong>空港</strong>カウンターでの預け入れ時と、<strong>ホテル</strong>のフロントでの受け取り時にこのコードを提示してください。',
            descriptionSub: 'お荷物は、ご入力いただいた情報に基づき、指定のホテルへお届けします。',
            cutoffTime: '⚠️ 当日配送締切：<strong>{cutoffTime}</strong>（日本時間, UTC+9）',
            separateNote: '注意：本パスは航空券や宿泊予約とは別のものです。',
            alt: 'QR荷物配送パス（空港・ホテル提示用）',
            trademark: 'QRコードは株式会社デンソーウェーブの登録商標です。',
        },
        share: {
            button: 'QRコードと情報を共有',
            downloadButton: 'QRコードをダウンロード',
            textOnlyHint: '※お使いのデバイスはテキスト共有のみ対応しています。QR画像は添付されません。',
        },
        airportInfo: {
            arrivalDateTime: '到着予定日時',
            flightNumber: '便名',
            accessGuideLink: 'カウンターへの行き方を確認する',
        },
        luggageInfo: {
            quantity: '現時点でのお預入れ予定の荷物個数',
            unit: '個',
            deliveryStatus: '配送状況',
        },
        luggagePhoto: {
            title: '荷物写真',
        },
        addressAnnotation: '(タクシーや現地の方への提示にご利用ください)',
        hotelInfo: {
            hotelAddress: 'ホテル所在地 (英語・日本語併記)',
        },
        confirmationItems: {
            sectionTitle: 'お申し込みありがとうございます',
            subtitle:
                'この度は Air Luggage をご利用いただき誠にありがとうございます。以下の重要事項をご確認の上、カウンターへお越しください。',
            importantNotes: '【重要：今後の流れとご注意】',
            deliverySchedule: {
                title: '1. 配送スケジュールについて',
                estimatedArrival: {
                    label: 'お届けの目安',
                    description:
                        'ホテルへの到着は、お預け入れから<strong>約{hours}〜{hoursUpper}時間後</strong>を目安として順次配送いたします。',
                    note: '※<strong>当日の混雑状況や交通事情により到着時間は前後します。確約はいたしかねます</strong>ので予めご了承ください。',
                },
                cutoffTime: {
                    label: '当日配送の締切',
                    description: '{cutoffTime}を過ぎますと、いかなる理由でも<strong>翌日のお届け</strong>となります。',
                },
            },
            checkDeliveryStatus: {
                title: '2. 配送状況の確認',
                description: '現在の配送状況は、お客様の<strong>マイページ</strong>よりご確認いただけます。',
                note: '<strong>ホテルへの配送状況のお問い合わせは不要です。</strong>',
            },
            inCaseOfDamage: {
                title: '3. 万が一のトラブル時',
                description:
                    '荷物に破損があった場合は、受け取りから<strong>24時間以内</strong>に、Air Luggage の窓口（<a href="{whatsappUrl}" target="_blank" rel="noopener">WhatsApp</a>・<a href="{lineUrl}" target="_blank" rel="noopener">LINE</a>）へご連絡ください。',
                note: '期限を過ぎた場合、規約により補償いたしかねます。',
            },
        },
    },
    confirmation: {
        title: '配送予約確認',
        sections: {
            customerInfo: 'お客様情報',
            confirmationItems: '確認事項',
        },
        customerInfo: {
            reservationHolderName: '宿泊予約名義',
            userName: '申込者名',
        },
        airportInfo: {
            airportName: '空港名',
            airportAddress: '空港住所',
            counterName: 'カウンター名',
            counterAddress: 'カウンター住所',
        },
        luggageInfo: {
            quantity: '現時点でのお預入れ予定の荷物個数',
            unit: '個',
        },
        luggagePhoto: {
            label: '荷物写真',
        },
        confirmationItems: {
            ...confirmationItemsJa,
            // 確認画面だけ、個数確認に合計額の了承の文を続ける（カウンターの同意画面は同じ部品を共有するので変えない＝REQ-000010 S82）
            itemCountConfirmation: {
                ...confirmationItemsJa.itemCountConfirmation,
                description: `${confirmationItemsJa.itemCountConfirmation.description}合計額が荷物の数で決まること、および入力した数より荷物が増えた場合は、増えた分を当日カウンターで支払うことを了承しました。`,
            },
            termsAndConditions: {
                ...confirmationItemsJa.termsAndConditions,
                description: confirmationItemsJa.termsAndConditions.description.replace(
                    confirmationItemsJa.itemCountConfirmation.description,
                    `${confirmationItemsJa.itemCountConfirmation.description}合計額が荷物の数で決まること、および入力した数より荷物が増えた場合は、増えた分を当日カウンターで支払うことを了承しました。`
                ),
            },
            agreeAll: '全て同意する',
        },
        submit: '予約を確定する',
        back: '< 入力内容を修正する',
        error: '申し込みの登録に失敗しました。再度お試しください。',
        duplicateApplication: '同じメールアドレス・ホテル・日程のお申込みがすでにあります。',
        priceChanged: '料金が変わりました。新しい合計額をご確認のうえ、もう一度「予約を確定する」を押してください。',
        dateUnavailable: '選択した日は、お申し込みいただけなくなりました。別の日付を選択してください。',
    },
    relationshipWithGuest: {
        self: '本人',
        family: '家族',
        friend: '友達',
        colleague: '同僚',
        other: 'その他',
    },
    deliveryStatus: {
        bookingConfirmed: '予約確定（カウンターでお預けください）',
        bagsReceivedAtCounter: 'お預かり完了',
        inTransit: '配送中（ホテルへ輸送中）',
        arrivedAtHotel: 'ホテルにお届け済み',
        pickedUp: 'お受け取り済み',
        cancelled: 'キャンセル済み',
        delayed: '遅延・要確認（スタッフへお尋ねください）',
    },
    serverError: {
        title: 'メンテナンス中',
        heading: 'ただいまメンテナンス中です',
        backToApplication: '申込画面に戻る',
        fallbackNotice: 'お手数ですが、ホテルからご案内のQRコードより、もう一度アクセスしてください。',
    },
    contact: {
        openButton: 'お問い合わせ',
        close: '閉じる',
        title: 'Air Luggage（手荷物配送）についてのお問い合わせ',
        note: '※ホテルのご予約（日程・料金・キャンセルなど）についてはお答えできません。ご宿泊のホテルへお問い合わせください。',
        whatsapp: 'WhatsAppで質問する',
        line: 'LINEで質問する',
        faq: 'よくある質問を見る',
        replyHours:
            '返信時間 9:00〜18:00（日本時間）。18時以降のお荷物の受け取りについては、ご宿泊のホテルのフロントへお問い合わせください。',
    },
};
